import axios from 'axios'

// Initial state
const state = {
  salesOrganizations: null
}

// Mutations
const mutations = {
  setSalesOrganizations (state, salesOrganizations) {
    state.salesOrganizations = salesOrganizations
  }
}

// Actions
const actions = {
  loadSalesOrganizations ({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('setSalesOrganizations', null)

      // Call the backend
      axios.get('/backend/rest/sales_organization')
        .then(response => {
          commit('setSalesOrganizations', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(Error(error.response.data))
        })
    })
  }
}

// Getters
const getters = {
  isSalesOrganizationsLoaded: (state) => {
    return state.salesOrganizations !== null
  },
  hasSalesOrganizations: (state) => {
    return state.salesOrganizations !== null && state.salesOrganizations.length
  },
  getSalesOrganizations: (state) => {
    return state.salesOrganizations
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js